export var MAX_CONTENT_WIDTH = '1616px';
